import { Alert, Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useGetBarcodeList } from "../../../hooks/into-warehouse/useGetBarcodeList";
import useBuyFactorStore from "../../../store/into-warehouse/useBuyFactorStore";
import LoadingSpinner from "../../global/loading-spinner";
import AddBarcode from "./add-barcode";
import BarcodeItem from "./barcode-item";

const useStyles = makeStyles((theme) => ({
  barcodeTop: {
    color: "#fff",
    padding: "16px 32px",
    textAlign: "center",
    position: "relative",
    zIndex: "2",
    [theme.breakpoints.down("360")]: {
      padding: "16px 14px",
    },
    "&:before": {
      position: "absolute",
      content: '""',
      width: "100%",
      height: "100%",
      background: "#2530B8",
      top: "0",
      right: "0",
      borderRadius: "0 0 75px 75px",
      zIndex: "-1",
      marginBottom: "30px",
    },
  },
}));

const BarcodeList = () => {
  const classes = useStyles();
  const factorID = useBuyFactorStore((store) => store.factorID);
  const productID = useBuyFactorStore((store) => store.productID);
  const productName = useBuyFactorStore((store) => store.productName);
  const date = useBuyFactorStore((store) => store.date);
  const { data, isLoading } = useGetBarcodeList(factorID, productID);

  return (
    <>
      <Box className="page-title">{productName}</Box>
      <Box className={classes.barcodeTop}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h3">{date}</Typography>
          <Typography variant="h3">شماره فاکتور: {factorID}</Typography>
        </Box>
        {/* <Box mt={4}>
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
            alt="kiamia-shop"
            width="100"
          />
        </Box> */}
        <AddBarcode factorID={factorID} productID={productID} />
      </Box>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box p={4}>
          {data?.result?.length === 0 ? (
            <Alert severity="warning">بارکدی موجود نیست.</Alert>
          ) : (
            <>
              {data?.result?.map(({ ...otherProps }, index) => (
                <BarcodeItem key={index} {...otherProps} />
              ))}
            </>
          )}
        </Box>
      )}
    </>
  );
};
export default BarcodeList;
